<template>
  <div class="search-panel" v-if="searchValue.length && !isSearchPageActive && !minLengthSearch">

    <!-- List -->
    <div class="search-panel-list" v-if="search.length >= 3 && visibleProducts.length">
      <search-item v-for="product in visibleProducts.slice(0, 4)"
                   :key="product.entity_id"
                   :product="product"
      />
    </div>
    <div class="search-panel-list" v-else-if="!getNoResultsMessage">
      <search-product-preloader v-for="item in preloaderItems" :key="item" />
    </div>
    <!---->

    <!-- Message -->
    <div class="search-panel-msg" v-else>
      <span class="search-panel-msg-text"> {{ $t(getNoResultsMessage) }} </span>
    </div>
    <!---->

    <!-- View all link -->
    <div class="search-panel-load" v-if="!minLengthSearch && visibleProducts.length">
      <span class="search-panel-load-text" @click="showSearchPage"> {{ $t('View all') }} {{ total }} {{ $t('products') }} </span>
    </div>
    <!---->

  </div>
</template>

<script>
import SearchItem from 'theme/components/core/blocks/Shop/Navigation/Search/SearchItem'
import SearchPanel from '@vue-storefront/core/compatibility/components/blocks/SearchPanel/SearchPanel'
import VueOfflineMixin from 'vue-offline/mixin'
import SearchProductPreloader from 'theme/components/theme/blocks/Home/Preloaders/SearchProductPreloader'
import { minLength } from 'vuelidate/lib/validators'
import { debounce } from 'lodash'

export default {
  components: {
    SearchItem,
    SearchProductPreloader
  },
  mixins: [SearchPanel, VueOfflineMixin],
  props: {
    searchValue: {
      type: String
    },
    isSearchPageActive: {
      type: Boolean
    }
  },
  validations: {
    search: {
      minLength: minLength(3)
    }
  },
  data () {
    return {
      debounceSearch: () => {},
      selectedCategoryIds: [],
      isCreated: false,
      preloaderItems: 4
    }
  },
  created () {
    this.$bus.$on('hide-search-panel', () => this.hideSearchPanel())
    this.debounceSearch = debounce(this.makeSearch, 500)
  },
  mounted () {
    this.search = this.searchValue
  },
  watch: {
    categories () {
      this.selectedCategoryIds = []
    },
    searchValue () {
      this.search = this.searchValue
    },
    search () {
      if (!this.minLengthSearch) {
        this.debounceSearch()
      }
    },
    '$route.path': {
      handler: function () {
        this.$bus.$emit('hide-search-panel')
        this.$bus.$emit('hide-overlay-in-shop')
      }
    }
  },
  computed: {

    visibleProducts () {
      const productList = this.products || []
      if (this.selectedCategoryIds.length) {
        return productList.filter(product => product.category_ids.some(categoryId => {
          const catId = parseInt(categoryId)
          return this.selectedCategoryIds.includes(catId)
        }))
      }
      return productList
    },
    categories () {
      const categories = this.products.filter(p => p.category).map(p => p.category).flat().filter(c => c.name)
      const discinctCategories = Array.from(new Set(categories.map(c => c.category_id))).map(catId => categories.find(c => c.category_id === catId))
      return discinctCategories
    },
    getNoResultsMessage () {
      let msg = ''
      if (this.emptyResults) msg = 'No results were found.'
      return msg
    },
    minLengthSearch () {
      return this.search.length < 3
    }
  },
  methods: {
    hideSearchPanel () {
      this.$bus.$emit('clear-search-value')
    },
    showSearchPage () {
      this.$bus.$emit('hide-search-panel')
      this.$bus.$emit('hide-overlay-in-shop')
      this.processPartnerSearch(this.search)
    },
  }
}
</script>

<style lang="scss" scoped>
.search-panel {
  width: 520px;
  padding: 20px;
  margin: auto;

  display: block;
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;

  background: #fff;
  border-radius: 5px;

  transition: .2s;

  @media only screen and (max-width: 1200px) {
    width: 450px;
    left: 130px;
  }

  @media only screen and (max-width: 991px) {
    width: 340px;
    left: 20px;
  }

  @media only screen and (max-width: 768px) {
    width: 370px;
    left: 0;
  }

  @media only screen and (max-width: 576px) {
    width: 100%;
    border-radius: 0;
    box-sizing: border-box;
  }

  &-list {
    display: flex;
    flex-direction: column;
  }

  &-msg {
    width: 100%;
    text-align: center;
  }

  &-load {
    margin-top: 10px;
    text-align: center;

    &-text {
      color: #11bb2e;
      font-size: 14px;
      font-weight: 400;

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
}
</style>
